import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Popover, Button} from 'antd'
import SignalField from 'Components/Builder/Signal'
import TickersInput from 'Components/Builder/TickersInput'
import StockFilterSelect from 'Components/Builder/StockFilterSelect'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import style from './algoEditor.sass'

const popovers = {
  stock_filter: (
    <div>
      You can create new lists on the <Link to="/stock-filters/builder">Screener</Link> page
    </div>
  )
}

@inject('store') @observer
class AlgoEditor extends Component {
  changeTickers = (value) => {
    this.props.store.algo.single.change('tickers', value)
  }
  removeError = (name) => {
    this.props.store.algo.single.removeError(name)
  }
  render() {
    const {algo} = this.props.store
    const {tickers} = algo.single.data
    const {data, errors} = algo.single
    const type = data.has_coin ? 3 : 1
    return(
      <div className='card' styleName='wrapper'>
        <div>
          <label>Signal:</label>
          <SignalField name='signal'/>
        </div>
        <div>
          <div styleName='tickers'>
            <label>Tickers:</label>
            <TickersInput
              name='tickers'
              type={type}
              changeHandler={this.changeTickers}
              tickers={tickers}
              errors={errors}
              removeError={this.removeError}
            />
          </div>
          <div>
            <label>Ticker lists:</label>
            <Popover
              content={popovers.stock_filter}
              placement='right'
              styleName='popover'
            >
              <span>
                <FontAwesomeIcon icon='question-circle'/>
              </span>
            </Popover>
            <StockFilterSelect
              changeHandler={this.props.changeHandler}
            />
          </div>
        </div>
        <Button
          styleName='close-btn'
          onClick={this.props.close}
        >
          <FontAwesomeIcon icon='times'/>
        </Button>
      </div>
    )
  }
}

export default AlgoEditor
